/**
 * Instituições do SPEI (México) e regras da CLABE, para a tela e para o backend.
 *
 * Fonte: BlindPay GET /v1/available-bank-details?rail=spei_bitso. Código Banxico de 5 dígitos
 * (37XXX desenvolvimento, 40XXX comerciais, 90XXX fintechs/cajas). Os 3 últimos dígitos do código
 * são os 3 primeiros da CLABE — é assim que o banco sai da CLABE quando o cadastro não informa.
 * Resincronizar quando a BlindPay publicar novos participantes.
 */

const SPEI_INSTITUTIONS = Object.freeze([
  { name: 'Actinver', code: '40133' },
  { name: 'Afirme', code: '40062' },
  { name: 'Albo', code: '90721' },
  { name: 'Altor', code: '90660' },
  { name: 'Arcus FI', code: '90706' },
  { name: 'ASP Integra OPC', code: '90659' },
  { name: 'Babien', code: '37166' },
  { name: 'Banamex', code: '40002' },
  { name: 'Banco Azteca', code: '40127' },
  { name: 'Banco Covalto', code: '40154' },
  { name: 'Banco del Bajío', code: '40030' },
  { name: 'Banco Inbursa', code: '40036' },
  { name: 'Banco S3', code: '40160' },
  { name: 'Bancomext', code: '37006' },
  { name: 'Bancoppel', code: '40137' },
  { name: 'Bancrea', code: '40152' },
  { name: 'Banjercito', code: '37019' },
  { name: 'Bank of America', code: '40106' },
  { name: 'Bank of China', code: '40159' },
  { name: 'Bankaool', code: '40147' },
  { name: 'Banobras', code: '37009' },
  { name: 'Banorte', code: '40072' },
  { name: 'Banregio', code: '40058' },
  { name: 'Bansi', code: '40060' },
  { name: 'Barclays', code: '40129' },
  { name: 'BBASE', code: '40145' },
  { name: 'BBVA Bancomer', code: '40012' },
  { name: 'BMonex', code: '40112' },
  { name: 'Caja Pop Mexica', code: '90677' },
  { name: 'Caja Telefonist', code: '90683' },
  { name: 'Cashi Cuenta', code: '90715' },
  { name: 'Citi Mexico', code: '40124' },
  { name: 'Clip', code: '90730' },
  { name: 'Compartamos Banco', code: '40130' },
  { name: 'Consubanco', code: '40140' },
  { name: 'Coopdesarrollo', code: '90725' },
  { name: 'Credicapital', code: '90652' },
  { name: 'Crediclub', code: '90688' },
  { name: 'Cristobal Colon', code: '90680' },
  { name: 'Cuenca', code: '90723' },
  { name: 'Dep y Pag Dig', code: '90729' },
  { name: 'Donde', code: '40151' },
  { name: 'Finamex', code: '90616' },
  { name: 'Finco Pay', code: '90734' },
  { name: 'Fincomun', code: '90634' },
  { name: 'Fintoc', code: '90738' },
  { name: 'Fondeadora', code: '90699' },
  { name: 'Fondo (FIRA)', code: '90685' },
  { name: 'GBM', code: '90601' },
  { name: 'Hey Banco', code: '40167' },
  { name: 'Hipotecaria Fed', code: '37168' },
  { name: 'HSBC', code: '40021' },
  { name: 'ICBC', code: '40155' },
  { name: 'Indeval', code: '90902' },
  { name: 'Inmobiliario', code: '40150' },
  { name: 'Intercam Banco', code: '40136' },
  { name: 'Invex', code: '40059' },
  { name: 'JP Morgan', code: '40110' },
  { name: 'Kapital', code: '40128' },
  { name: 'Klar', code: '90661' },
  { name: 'Kuspit', code: '90653' },
  { name: 'Libertad', code: '90670' },
  { name: 'Masari', code: '90602' },
  { name: 'Mercado Pago W', code: '90722' },
  { name: 'MexPago', code: '90720' },
  { name: 'Mifel', code: '40042' },
  { name: 'Mizuho Bank', code: '40158' },
  { name: 'MonexCB', code: '90600' },
  { name: 'MUFG', code: '40108' },
  { name: 'Multiva Banco', code: '40132' },
  { name: 'NAFIN', code: '37135' },
  { name: 'Nubank', code: '40638' },
  { name: 'NVIO Pagos Mexico', code: '90710' },
  { name: 'Pagatodo', code: '40148' },
  { name: 'Peibo', code: '90732' },
  { name: 'PPBalanceMX', code: '90714' },
  { name: 'Profuturo', code: '90620' },
  { name: 'Revolut Bank', code: '40170' },
  { name: 'Sabadell', code: '40156' },
  { name: 'Santander', code: '40014' },
  { name: 'Scotiabank', code: '40044' },
  { name: 'Shinhan', code: '40157' },
  { name: 'Spin by OXXO', code: '90728' },
  { name: 'STP', code: '90646' },
  { name: 'Tesored', code: '90703' },
  { name: 'Transfer', code: '90684' },
  { name: 'Transfer Directo', code: '90727' },
  { name: 'TRF', code: '90631' },
  { name: 'UALA', code: '40138' },
  { name: 'Unagra', code: '90656' },
  { name: 'Valmex', code: '90617' },
  { name: 'Value', code: '90605' },
  { name: 'Ve por Mas', code: '40113' },
  { name: 'Volkswagen', code: '40141' }
]);

const CLABE_LENGTH = 18;
const CLABE_WEIGHTS = [3, 7, 1];

function _digits(value) {
  return String(value || '').replace(/\D/g, '');
}

/**
 * CLABE com 18 dígitos e dígito verificador certo (pesos 3, 7, 1 sobre os 17 primeiros).
 * @param {string} clabe
 * @returns {boolean}
 */
function isValidClabe(clabe) {
  const digits = _digits(clabe);

  if (digits.length !== CLABE_LENGTH || digits !== String(clabe).replace(/[\s-]/g, '')) return false;

  const sum = digits.slice(0, CLABE_LENGTH - 1).split('')
    .reduce((total, digit, index) => total + ((Number(digit) * CLABE_WEIGHTS[index % 3]) % 10), 0);

  return (10 - (sum % 10)) % 10 === Number(digits[CLABE_LENGTH - 1]);
}

/**
 * Instituição pelos 3 primeiros dígitos da CLABE, ou null.
 * @param {string} clabe
 * @returns {{ name: string, code: string }|null}
 */
function institutionOfClabe(clabe) {
  const bankDigits = _digits(clabe).slice(0, 3);

  if (bankDigits.length !== 3) return null;

  return SPEI_INSTITUTIONS.find((institution) => institution.code.slice(-3) === bankDigits) || null;
}

/**
 * Instituição pelo código de 5 dígitos, ou null.
 * @param {string} code
 */
function institutionByCode(code) {
  return SPEI_INSTITUTIONS.find((institution) => institution.code === _digits(code)) || null;
}

export { SPEI_INSTITUTIONS, CLABE_LENGTH, isValidClabe, institutionOfClabe, institutionByCode };

export default { SPEI_INSTITUTIONS, CLABE_LENGTH, isValidClabe, institutionOfClabe, institutionByCode };
